import { ServicePoint } from "./service-point";
import { ChangeType } from "../../enums/change-type.enum";
import { ShipmentDetailStatus } from "../../enums/shipmentdetail-status.enum";
import { TransitEvent } from "./transit-event";
import { DestinationType } from "./DestinationType";
export const codigosProductosDDI = ["110", "111", "112", "114"];
export class Expedition {
      ExpeditionNumber: string;
      ZipCode: string;
      DeliveredInServicePoint: boolean;
      DeliveryDate: string | null;
      Status: ShipmentDetailStatus;
      DeliveryOnSaturday: boolean;
      ChangeDeliveryDay: boolean;
      NeighborDelivery: boolean;
      ServicePointDelivery: boolean;
      SafePlaceDelivery: boolean;
      NewAddressDelivery: boolean;
      TLGNumber: string;
      CustomerEmail: string;
      Modified: boolean;
      RetryDelivery: boolean;
      DateText: string;
      ChangeType: ChangeType;
      ServicePoint: ServicePoint;
      Street: string;
      Town: string;
      Consignee: string;
      Sender: string;
      PickupDate: string;
      DeliveryPlace: string;
      LicensePlate: string;
      Tracking: TransitEvent[];
      DeliveredInNeighbor: boolean;
      CanBeModified: boolean;
      Origin: string;
      Destination: string;
      Product: string;
      Weight: string;
      InternationalNumber: string;
      ItemsNumber: string;
      CustomerReference: string;
      IncidenceSolution: string;
      ProductType: string;
      IncidenceNumber: number | null;
      IncidenceAgencyCode: string;
      ProductCode: string;
      OriginCode: string;
      DestinationCode: string;
      EPOD: boolean;
      Language: string;
      WithoutDirection: boolean;
      ShippingDate: string | null;
      NoRS: boolean;
      DestinationType: DestinationType;
      LastIncidence: string;
      PostageDue: boolean; 
      DaysInServicePoint: number | null;
      DateAvailableInServicePoint: string | null;
}
